import { render, staticRenderFns } from "./_SortableHeaderCell.vue?vue&type=template&id=4379907c&scoped=true&"
import script from "./_SortableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./_SortableHeaderCell.vue?vue&type=script&lang=js&"
import style0 from "./_SortableHeaderCell.vue?vue&type=style&index=0&id=4379907c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4379907c",
  null
  
)

export default component.exports